<template>
  <div class="space-y-3">
    <label
        v-for="answer in answers"
        :key="answer.id"
        class="flex items-start p-4 rounded-lg border-2 border-zinc-200 cursor-pointer transition-all hover:bg-gray-50"
    >
      <input
          type="checkbox"
          :value="answer.id"
          :checked="isSelected(answer.id)"
          @change="handleToggle(answer.id)"
          class="sr-only"
      />
      <div
          class="flex-shrink-0 w-5 h-5 rounded border-2 mr-3 mt-0.5 flex items-center justify-center border-zinc-200"
      >
        <Icon
            v-if="isSelected(answer.id)"
            name="check"
            class="w-4 h-4 text-zinc-600 !text-lg"
        />
      </div>
      <span
          class="text-zinc-600"
          :class="isSelected(answer.id)
          ? 'font-semibold'
          : 'font-normal'"
      >
        {{ answer.text }}
      </span>
    </label>
  </div>
</template>

<script setup>
import { Icon } from "@/components/block/icon";

const props = defineProps({
  answers: {
    type: Array,
    required: true
  },
  selectedAnswerIds: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(["select"]);

const isSelected = (answerId) => {
  return props.selectedAnswerIds.includes(answerId);
};

const handleToggle = (answerId) => {
  const newSelection = isSelected(answerId)
      ? props.selectedAnswerIds.filter((id) => id !== answerId)
      : [...props.selectedAnswerIds, answerId];

  emit("select", newSelection);
};
</script>
